import { Component, OnInit } from '@angular/core';
import { SigninService } from './signin.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SigninResponseVO, SigninRequestVO } from "./signin.models";
import { RouterModule, Routes } from '@angular/router';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { ApplicationError } from '../common/error.model';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {

  signInForm: FormGroup;
  forgotPasswordForm: FormGroup;
  signInResponse: SigninResponseVO;
  validationFailed: boolean;
  responseObject: SigninResponseVO;
  redirectUrl: string;
  statusMsg: string;
  forgotPasswordStatusMsg: string;
  forgotPassword: boolean;

  constructor(private formBuilder: FormBuilder,
    private signinService: SigninService,
    private router: Router,
    private route: ActivatedRoute) { }


  ngOnInit() {
    this.forgotPassword = false;
    this.signInForm = this.formBuilder.group({
      username: [null, Validators.required],
      password: [null, [Validators.required]]
    });
    this.forgotPasswordForm = this.formBuilder.group({
      forgotPasswordUsername: [null, Validators.required]
    });
    this.route.queryParams.forEach((params: Params) => {
      this.redirectUrl = params['redirectUrl'];
  });

  }
  submitForm(form: any): void {
    let signinRequestVO = new SigninRequestVO();
    signinRequestVO.setUsername(this.signInForm.value.username);
    signinRequestVO.setPassword(this.signInForm.value.password);
    this.signInForm.reset();
    this.signinService.signin(signinRequestVO).then(
      signinResponseVO => {
        this.handleSuccessResponse(signinResponseVO);
      },
      errorResponse => {
        this.statusMsg = "Unknown Error";
        this.validationFailed = true;
        if(errorResponse instanceof ApplicationError){
          this.statusMsg = errorResponse.statusMsg;
        };
      }
    );
  }

  submitForgotPasswordForm(form: any): void {
    this.signinService.requestResetLinkMail(this.forgotPasswordForm.value.forgotPasswordUsername).then(
      response => {
        this.forgotPasswordStatusMsg = "Reset password mail sent";
      },
      errorResponse => {
        this.forgotPasswordStatusMsg = "Unknown Error";
        if(errorResponse instanceof ApplicationError){
          this.forgotPasswordStatusMsg = errorResponse.statusMsg;
        };
      }
    );
    this.forgotPasswordForm.reset();
  }

  private handleSuccessResponse(responseObject: SigninResponseVO) {
    //????handle only success response
    //this.router.navigate(['profile', JSON.stringify(responseObject)]);
    //this.redirectUrl = '${this.redirectUrl}?encodeURI(accessToken=${responseObject.getAccessToken()}&refreshToken=${responseObject.getRefreshToken()}';
    
    if(this.redirectUrl==null){
      this.router.navigate(['/profile']);
    }
    else{
      this.redirectUrl = this.redirectUrl+'?accessToken='+encodeURIComponent(responseObject.getAccessToken())+'&refreshToken='+encodeURIComponent(responseObject.getRefreshToken());
      window.location.href = this.redirectUrl;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/signin/signin.component.ts